import { Controller, useFormContext } from 'react-hook-form';
import SimpleToggleButton from '../../SimpleToggleButton';

type WizardToggleFieldProps = {
  label: string;
  name: string;
  helperText?: string;
};

export const WizardToggleField = ({
  label,
  name,
  helperText = '',
}: WizardToggleFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = (errors[name]?.message as string) || helperText;
  const isError = !!errors[name];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SimpleToggleButton
          {...field}
          label={label}
          helperText={errorMessage}
          error={isError}
          buttonProps={{
            color: 'primary',
            sx: {
              'padding': '4px',
            }
          }}
        />
      )}
    />
  );
};

